  (function(){
    var nav = document.querySelector('[data-wubs-nav-dropdown]:not([data-wubs-nav-initialized])');
    if(!nav) return;
    nav.setAttribute('data-wubs-nav-initialized', 'true');
    var sid = nav.getAttribute('data-wubs-nav-sid') || 'wubs';
    var header = document.getElementById('wubs-header-' + sid);
    if(!header) return;

    window.__wubsNavDDInit = window.__wubsNavDDInit || {};
    if(window.__wubsNavDDInit[sid]) return;
    window.__wubsNavDDInit[sid] = true;

    var panels = header.querySelectorAll('[data-wubs-dd-split]');
    if(panels && panels.length){
      function initPanel(panel){
        if(panel._wubsInited) return;
        panel._wubsInited = true;

        var grid = panel.querySelector('[data-wubs-dd-grid]');
        var empty = panel.querySelector('[data-wubs-dd-empty]');
        var linksWrap = panel.querySelector('[data-wubs-dd-links]');
        if(!grid || !linksWrap) return;

        var templates = panel.querySelectorAll('template[data-wubs-dd-template]');
        var map = {};
        for(var i=0;i<templates.length;i++){
          var k = templates[i].getAttribute('data-wubs-dd-template');
          if(k) map[k] = templates[i];
        }

        function syncGridCount(){
          var count = grid.querySelectorAll('.wubs-ddp__card').length || 0;
          grid.setAttribute('data-count', String(count));
        }

        function setActiveLink(key){
          var links = linksWrap.querySelectorAll('[data-wubs-dd-key]');
          for(var j=0;j<links.length;j++){
            var a = links[j];
            a.classList.toggle('is-preview-active', a.getAttribute('data-wubs-dd-key') === key);
          }
        }

        function show(key){
          if(!key || !map[key]) return false;
          var html = (map[key].innerHTML || '').trim();

          if(!html){
            grid.innerHTML = '';
            syncGridCount();
            if(empty) empty.hidden = false;
            setActiveLink(key);
            return true;
          }

          grid.innerHTML = html;
          syncGridCount();
          if(empty) empty.hidden = (grid.querySelectorAll('.wubs-ddp__card').length > 0);
          setActiveLink(key);
          return true;
        }

        var initial = panel.getAttribute('data-initial-key') || '';
        if(initial) setActiveLink(initial);
        syncGridCount();

        linksWrap.addEventListener('pointerover', function(e){
          var a = e.target && e.target.closest ? e.target.closest('[data-wubs-dd-key]') : null;
          if(!a) return;
          show(a.getAttribute('data-wubs-dd-key') || '');
        });

        linksWrap.addEventListener('focusin', function(e){
          var a = e.target && e.target.closest ? e.target.closest('[data-wubs-dd-key]') : null;
          if(!a) return;
          show(a.getAttribute('data-wubs-dd-key') || '');
        });
      }

      for(var p=0;p<panels.length;p++) initPanel(panels[p]);
    }

    var fine = false;
    try{
      fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    }catch(e){
      fine = false;
    }
    if(!fine) return;

    var backdrop = header.querySelector('.wubs-dd__backdrop');
    var ddItems = Array.prototype.slice.call(header.querySelectorAll('[data-wubs-dd-item]'));
    if(!ddItems.length) return;

    var activeItem = null;
    var closeTimer = null;

    function getTrigger(item){
      return item ? item.querySelector('[data-wubs-dd-trigger]') : null;
    }

    function getPanel(item){
      return item ? item.querySelector('[data-wubs-dd-panel]') : null;
    }

    function clearCloseTimer(){
      if(closeTimer){
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function syncMenuState(){
      header.classList.toggle('is-menu-open', !!activeItem);
    }

    function setExpanded(item, expanded){
      var trigger = getTrigger(item);
      if(trigger){
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function closeItem(item){
      if(!item) return;
      item.classList.remove('is-dd-open');
      setExpanded(item, false);
    }

    function closeAll(){
      clearCloseTimer();
      for(var i=0;i<ddItems.length;i++){
        closeItem(ddItems[i]);
      }
      activeItem = null;
      syncMenuState();
    }

    function openItem(item){
      if(!item) return;
      clearCloseTimer();

      if(activeItem && activeItem !== item){
        closeItem(activeItem);
      }

      activeItem = item;
      item.classList.add('is-dd-open');
      setExpanded(item, true);
      syncMenuState();
    }

    function scheduleClose(item, delay){
      clearCloseTimer();
      closeTimer = setTimeout(function(){
        if(activeItem === item){
          closeItem(item);
          activeItem = null;
          syncMenuState();
        }
      }, delay || 160);
    }

    function isInsideSameItem(item, target){
      if(!item || !target) return false;
      return item.contains(target);
    }

    function bindItem(item){
      var trigger = getTrigger(item);
      var panel = getPanel(item);
      if(!trigger) return;

      trigger.addEventListener('pointerenter', function(){
        openItem(item);
      });

      trigger.addEventListener('pointerleave', function(e){
        if(isInsideSameItem(item, e.relatedTarget)) return;
        scheduleClose(item, 180);
      });

      trigger.addEventListener('focusin', function(){
        openItem(item);
      });

      trigger.addEventListener('click', function(e){
        if(activeItem !== item){
          e.preventDefault();
          openItem(item);
        }
      });

      if(panel){
        panel.addEventListener('pointerenter', function(){
          clearCloseTimer();
          openItem(item);
        });

        panel.addEventListener('pointerleave', function(e){
          if(isInsideSameItem(item, e.relatedTarget)) return;
          scheduleClose(item, 140);
        });

        panel.addEventListener('focusin', function(){
          openItem(item);
        });

        panel.addEventListener('focusout', function(){
          setTimeout(function(){
            if(!item.contains(document.activeElement) && activeItem === item){
              scheduleClose(item, 0);
            }
          }, 0);
        });
      }
    }

    for(var i=0;i<ddItems.length;i++){
      bindItem(ddItems[i]);
    }

    if(backdrop){
      backdrop.addEventListener('click', function(){
        closeAll();
      });
    }

    document.addEventListener('pointerdown', function(e){
      if(!header.contains(e.target)){
        closeAll();
      }
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        var openTrigger = getTrigger(activeItem);
        closeAll();
        if(openTrigger) openTrigger.focus();
      }
    });
  })();
